import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  notifications: null,
  notificationsRef: null
}

const getters = {
  notifications (state) {
    return state.notifications
  },
  notificationsRef (state) {
    return state.notificationsRef
  }
}

const mutations = {
  setNotifications (state, payload) {
    state.notifications = payload
  },
  setNotificationsRef (state, payload) {
    state.notificationsRef = payload
  }
}

const actions = {
  loadNotifications: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('notifications')
    ref.on('value', snapshot => {
      const notifications = []
      snapshot.forEach(n => {
        notifications.push({ key: n.key, ...n.val() })
      })
      store.commit('setNotifications', notifications)
      store.commit('setNotificationsRef', ref)
      resolve()
    })
  }),
  deleteNotification: (store, payload) => new Promise((resolve, reject) => {
    store.getters.notificationsRef.child(payload.key).remove().then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js